export const URL_STATIC = process.env.REACT_APP_URL_STATIC ?? ''
export const APIKEY_AD = process.env.REACT_APP_APIKEY_AD ?? ''
export const APIKEY_LETTER = process.env.REACT_APP_APIKEY_LETTER ?? ''